// WhatsApp SVG Icon
import React from 'react';

const WhatsAppIcon = ({ className = '', ...props }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="16" cy="16" r="16" fill="#25D366" />
    <path
      d="M23.472 19.339c-.355-.177-2.104-1.037-2.43-1.155-.326-.119-.563-.177-.8.177-.237.355-.914 1.155-1.122 1.392-.207.237-.414.266-.77.089-.355-.178-1.5-.553-2.86-1.763-1.057-.944-1.77-2.108-1.98-2.463-.207-.355-.022-.547.155-.724.159-.158.355-.414.533-.622.178-.207.237-.355.355-.592.119-.237.06-.444-.03-.622-.089-.178-.8-1.924-1.096-2.637-.289-.693-.583-.599-.8-.61-.207-.009-.444-.011-.681-.011-.237 0-.622.089-.948.444-.326.355-1.24 1.211-1.24 2.955 0 1.744 1.268 3.428 1.445 3.666.178.237 2.5 3.82 6.055 5.207.847.292 1.507.466 2.022.596.849.203 1.624.174 2.236.106.682-.075 2.104-.859 2.402-1.691.296-.832.296-1.545.207-1.691-.089-.148-.326-.237-.681-.414z"
      fill="#fff"
    />
  </svg>
);

export default WhatsAppIcon;
